/** Short history (last navigations, clicks, failed requests) attached to every Fehlerprotokoll report (ADR 0022). */

const MAX_CRUMBS = 30
const crumbs: string[] = []

export function breadcrumb(text: string): void {
  crumbs.push(`${new Date().toTimeString().slice(0, 8)} ${text.slice(0, 160)}`)
  if (crumbs.length > MAX_CRUMBS) crumbs.splice(0, crumbs.length - MAX_CRUMBS)
}

export const getBreadcrumbs = (): string[] => [...crumbs]
